import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pallet-current',
  templateUrl: './pallet-current.component.html',
  styleUrls: ['./pallet-current.component.scss']
})
export class PalletCurrentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
